import { ProfileProvider } from '@/providers/profile/profile.provider';
import { inject, Injectable } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { firstValueFrom, type Observable } from 'rxjs';
import { BusinessIndicatorsService } from './details/services/business-indicators.service';

@Injectable({
    providedIn: 'root'
})
export class BusinessIndicatorsFeatureService {
    private _router = inject(Router);
    private _profileProvider = inject(ProfileProvider);
    private _businessIndicatorsService = inject(BusinessIndicatorsService);

    goToFeature() {
        this._router.navigate(['/', 'business-indicators', 'details']);
    }

    goToAdminFeature() {
        this._router.navigate(['/', 'admin', 'business-indicators']);
    }

    hasFeatureAccess$(): Observable<boolean> {
        return this._businessIndicatorsService.hasAccessToBusinessIndicator$();
    }

    hasFeatureAccess(): Promise<boolean> {
        return firstValueFrom(this.hasFeatureAccess$());
    }

    hasAdminFeatureAccess$(): Observable<boolean> {
        return this._profileProvider.isProjectAdmin$();
    }
}

export const businessIndicatorGuard: CanActivateFn & CanActivateChildFn = async () => {
    const featureService = inject(BusinessIndicatorsFeatureService);
    const hasFeatureAccess = await featureService.hasFeatureAccess();

    if (!hasFeatureAccess) {
        return false;
    }
    return true;
};

export const adminBusinessIndicatorGuard: CanActivateFn & CanActivateChildFn = async () => {
    const featureService = inject(BusinessIndicatorsFeatureService);
    const hasFeatureAccess = await firstValueFrom(featureService.hasAdminFeatureAccess$());

    if (!hasFeatureAccess) {
        return false;
    }
    return true;
};
